/**
 * Horizontal bar list showing ranked items with relative widths.
 */

import { cn } from "@/lib/utils";

type RankedItem = {
  label: string;
  value: number;
  formattedValue?: string;
};

type RankedListProps = {
  items: RankedItem[];
  className?: string;
  color?: string;
};

export function RankedList({ items, className, color = "bg-primary/20" }: RankedListProps) {
  const max = Math.max(...items.map((i) => i.value), 1);

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      {items.map((item) => {
        const widthPct = Math.max((item.value / max) * 100, 2);
        return (
          <div key={item.label} className="flex items-center gap-3">
            <span className="w-24 shrink-0 truncate text-sm text-muted-foreground">
              {item.label}
            </span>
            <div className="relative flex-1 h-6">
              <div
                className={cn("absolute inset-y-0 left-0 rounded-sm", color)}
                style={{ width: `${widthPct}%` }}
              />
              <span className="relative z-10 flex h-full items-center px-2 text-xs font-medium">
                {item.formattedValue ?? item.value}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
